import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class UserGroupApi extends CollectionApi {
  constructor() {
    super('/api/v2/usergroups', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
        value: '',
      }],
    });
  }

  acceptSuggestions(id, payload) {
    return this.initialize()
      .then(() => axios.post(`${this.baseUrl}/${id}/suggestions`, payload))
      .then(resp => resp.data);
  }

  fetchActiveDirectories(id) {
    return this.initialize()
      .then(() => axios.get(`${this.baseUrl}/${id}/activedirectories`))
      .then(resp => resp.data);
  }

  async fetchSuggestions(id, params) {
    await this.initialize();
    const res = await axios.get(`${this.baseUrl}/${id}/suggestions`, params);
    return {
      results: res.data,
      totalCount: +res.headers['x-total-count'],
    };
  }

  async fetchDeviceGroups(id) {
    await this.initialize();
    const response = await axios.get(`${this.baseUrl}/${id}/systemgroups?details=v1&limit=100`);
    return {
      results: response.data,
      totalDeviceGroupCount: response.headers['x-total-count'],
    };
  }

  async fetchUserGroupById(id) {
    await this.initialize();
    const response = await axios.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async fetchTotalUserGroups() {
    await this.initialize();
    const res = await axios.get(`${this.baseUrl}/?skip=0&limit=1`);
    return {
      results: res.data,
      totalCount: +res.headers['x-total-count'],
    };
  }
}

export default new UserGroupApi();
